<template>
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 0.625C12.2148 0.625 12.625 1.03516 12.625 1.52734V12C12.625 12.4922 12.2148 12.875 11.75 12.875H1.22266C0.757812 12.875 0.375 12.4922 0.375 12V1.52734C0.375 1.03516 0.757812 0.625 1.22266 0.625H11.75ZM4.06641 11.125V5.30078H2.26172V11.125H4.06641ZM3.16406 4.48047C3.73828 4.48047 4.20312 4.01562 4.20312 3.44141C4.20312 2.86719 3.73828 2.375 3.16406 2.375C2.5625 2.375 2.09766 2.86719 2.09766 3.44141C2.09766 4.01562 2.5625 4.48047 3.16406 4.48047ZM10.875 11.125V7.92578C10.875 6.36719 10.5195 5.13672 8.6875 5.13672C7.8125 5.13672 7.21094 5.62891 6.96484 6.09375H6.9375V5.30078H5.21484V11.125H7.01953V8.25391C7.01953 7.48828 7.15625 6.75 8.11328 6.75C9.04297 6.75 9.04297 7.625 9.04297 8.28125V11.125H10.875Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#000000',
  },
});
</script>
